import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';
import { formatPrice } from '../utils/api';
import './Cart.css';

export default function Cart() {
  const { items, removeFromCart, updateQuantity, subtotal, shippingCost, taxAmount, total } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleCheckout = () => {
    if (!user) {
      navigate('/login?redirect=/checkout');
    } else {
      navigate('/checkout');
    }
  };

  if (items.length === 0) {
    return (
      <div className="container">
        <div className="empty-state" style={{ paddingTop: 100 }}>
          <div className="empty-icon">🛒</div>
          <h3>Your cart is empty</h3>
          <p>Add some beautiful plants to get started!</p>
          <Link to="/shop" className="btn btn-primary" style={{ marginTop: 20 }}>Browse Plants</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page container">
      <h1 className="section-title" style={{ marginBottom: 32 }}>Shopping Cart</h1>

      <div className="cart-layout">
        {/* Items */}
        <div className="cart-items">
          {items.map(item => {
            const price = item.discountPrice || item.price;
            return (
              <div key={item._id} className="cart-item card">
                <img
                  src={item.images?.[0]?.url}
                  alt={item.name}
                  className="cart-item-image"
                />
                <div className="cart-item-info">
                  <Link to={`/product/${item.slug || item._id}`} className="cart-item-name">{item.name}</Link>
                  <p className="cart-item-price">{formatPrice(price)}</p>
                </div>
                <div className="cart-item-actions">
                  <div className="qty-control">
                    <button onClick={() => updateQuantity(item._id, item.quantity - 1)}>−</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item._id, item.quantity + 1)}>+</button>
                  </div>
                  <p className="cart-item-subtotal">{formatPrice(price * item.quantity)}</p>
                  <button className="remove-btn" onClick={() => removeFromCart(item._id)} aria-label="Remove item">✕</button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Summary */}
        <div className="cart-summary card">
          <h2 className="summary-title">Order Summary</h2>

          <div className="summary-row"><span>Subtotal</span><span>{formatPrice(subtotal)}</span></div>
          <div className="summary-row">
            <span>Shipping</span>
            <span>{shippingCost === 0 ? '🎉 Free' : formatPrice(shippingCost)}</span>
          </div>
          <div className="summary-row"><span>GST (18%)</span><span>{formatPrice(taxAmount)}</span></div>
          <hr className="divider" />
          <div className="summary-row summary-total"><strong>Total</strong><strong>{formatPrice(total)}</strong></div>

          {shippingCost > 0 && (
            <p className="free-shipping-hint">
              Add {formatPrice(999 - subtotal)} more for free shipping!
            </p>
          )}

          <button className="btn btn-primary" style={{ width: '100%', marginTop: 20 }} onClick={handleCheckout}>
            Proceed to Checkout →
          </button>
          <Link to="/shop" className="btn btn-ghost" style={{ width: '100%', marginTop: 8, justifyContent: 'center' }}>
            ← Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
}
